(ns frontend.view.grid.common.components
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [common.schema.entity-type-names :as entity-type-names]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.view.entity-merge.view :as merge]
   [ui.components.button.view :as button]))

(defn card-settings-toolbar
  [toolbar kanban-db close-card-settings!]
  (if (:card-settings? @kanban-db)
    [:div
     {:class "px-4 py-3 flex justify-between bg-base-light border-b border-solid border-base-light-border-paler"}
     [:span
      [button/secondary-open
       {:class "!px-0 !py-0 gap-2"
        :on-click close-card-settings!}
       "< " (loc/tr :back)]]]
    toolbar))

(defn no-pipelines-in-use-view
  []
  [default-page-layout/view
   [:div.container.mt-5.pt-4.text-center
    [:div.container-sm
     [:div.max-width
      [:img
       {:src        "/img/undraw_File_searching_re_3evy.svg"
        :class-name "img-fluid"}]]
     [:h2.title-h3.my-4
      (loc/tr :no-active-pipelines)]]]])

(defn toolbar-delete-button
  [{:keys [allow-non-admin-delete? max-delete-count selected-items on-delete-clicked!]
    :or   {allow-non-admin-delete? false}}]
  (let [selected-count (count selected-items)
        disabled-text (cond (and (not allow-non-admin-delete?)
                                 (tenant-customizations/capman?)
                                 (not (session/is-admin?)))
                            (loc/tr :only-admin-can-delete-entities)
                            (> selected-count max-delete-count)
                            (loc/tr :grid-tooltip-cannot-delete-many-rows [max-delete-count max-delete-count]))
        disabled? (boolean disabled-text)]
    [button/sm-secondary-solid
     {:disabled? disabled?
      :tooltip   (when disabled?
                   disabled-text)
      :on-click  on-delete-clicked!}
     [:i.fal.fa-trash-alt {:aria-hidden true}]
     (loc/tr :delete)]))

(defn toolbar-bulk-edit-button
  [{:keys [max-bulk-edit-count selected-items on-bulk-edit-clicked!]}]
  (let [selected-count (count selected-items)
        disabled-text (when (> selected-count max-bulk-edit-count)
                        (loc/tr :grid-tooltip-cannot-bulk-edit-many-rows [max-bulk-edit-count max-bulk-edit-count]))
        disabled? (boolean disabled-text)]
    [button/sm-secondary-solid
     {:disabled? disabled?
      :tooltip   (when disabled?
                   disabled-text)
      :on-click  on-bulk-edit-clicked!}
     [:i.fal.fa-pen {:aria-hidden true}]
     (loc/tr :bulk-edit)]))

(defn toolbar-merge-button
  [{:keys [selected-items entity-type] :as _args}]
  (let [selected-count (count selected-items)
        disabled? (not= selected-count 2)
        et-plural-lc (fn [et]
                       (->> (entity-type-names/get-plural et :en)
                            string/lower-case))
        disabled-text (when disabled?
                        (loc/tr :entity-merge/select-exactly-entity
                            [(et-plural-lc entity-type)]))]
    [button/sm-secondary-solid
     {:disabled? disabled?
      :tooltip   (when disabled?
                   disabled-text)
      :on-click  (fn [_]
                   (apply merge/open-merge-modal! entity-type selected-items))}
     [:i.fal.fa-code-merge {:aria-hidden true}]
     (loc/tr :merge)]))
